import React, { useState } from "react";
import { string, node } from "prop-types";
import { generateNearlyUniqueID } from "common/uuid";
import "./instagram-story.styles.scss";

const propTypes = {
  profileImage: string.isRequired,
  username: string.isRequired,
  mediaSrc: string.isRequired,
  body: string,
  children: node
};

const InstagramStory = ({
  profileImage,
  username,
  mediaSrc,
  body = "Body goes here",
  children = null
}) => {
  const uuid = generateNearlyUniqueID();
  const [isLoaded, setIsLoaded] = useState(children);

  return (
    <div className="instagram-story" data-testid="instagram-story">
      <div className="story-header">
        <img src={profileImage} alt="Profile" className="story-profile-image" />
        <p className="story-username">{username}</p>
      </div>
      <div className="story-media">
        {children || (
          <img
            onLoad={() => setIsLoaded(true)}
            src={mediaSrc}
            alt="Story"
            className="story-media-element"
          />
        )}
        <div
          id={`placeholder-${uuid}`}
          className="instagram-story--loading"
          style={{ display: isLoaded ? "none" : "block" }}
        />
        <p className="story-body-text">{body}</p>
      </div>
    </div>
  );
};

InstagramStory.propTypes = propTypes;

export default InstagramStory;
